<template>
  <header :class="{ 'transparent': transparent }">
    <nav>
      <div class="logo-wrapper">
        <img :src="require('@/assets/images/logo-top.png')"/>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    transparent: Boolean
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  background-color: #FFFFFF;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16),0 2px 10px 0 rgba(0,0,0,0.12);

  &.transparent {
    background-color: transparent;
    box-shadow: none;
  }
}

nav {
  min-height: 54px;
  display: flex;
  align-items: center;
  padding: 10px;

  @include mq(lg) {
    padding: 20px;
  }

  .logo-wrapper {
    height: 30px;

    img {
      height: 100%;
    }
  }
}
</style>
